import { Link } from "react-router-dom";
import { faqs } from "@/mocks/site";

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  const preview = faqs.slice(0, 4);

  return (
    <section className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="grid gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-4">
            <span className="inline-flex items-center gap-2 rounded-md bg-secondary-100 px-2.5 py-1 text-xs font-semibold text-secondary-900">
              <i className="ri-question-answer-line" />
              常见问题
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              关于看料，你可能想问
            </h2>
            <p className="mt-4 text-sm leading-7 text-foreground-600">
              关于内容来源、更新频率与投稿方式等疑问，
              我们在这里为你逐一解答。还有更多问题？
              欢迎随时与我们取得联系。
            </p>
            <Link
              to="/faq"
              className="mt-6 inline-flex h-11 items-center gap-2 rounded-md bg-primary-500 px-6 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
            >
              查看全部问答 <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <div className="lg:col-span-8">
            <div className="space-y-3">
              {preview.map((item, idx) => {
                const on = open === idx;
                return (
                  <div
                    key={item.q}
                    className={`overflow-hidden rounded-xl border bg-background-50 transition-colors ${
                      on ? "border-primary-300" : "border-background-200/80"
                    }`}
                  >
                    <button
                      type="button"
                      onClick={() => setOpen(on ? null : idx)}
                      aria-expanded={on}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                    >
                      <span className="font-medium text-foreground-900">{item.q}</span>
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-all ${
                          on ? "rotate-180 bg-primary-500 text-background-50" : "bg-background-200/70 text-foreground-600"
                        }`}
                      >
                        <i className="ri-arrow-down-s-line text-lg" />
                      </span>
                    </button>
                    <div className={`grid transition-all duration-300 ${on ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}>
                      <div className="overflow-hidden">
                        <p className="px-5 pb-5 text-sm leading-7 text-foreground-600">{item.a}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}